import { makeVar } from '@apollo/client';

export const invalidMajor = makeVar<boolean>(false);
